const PATHS = {
    HOME: '/',
    ABOUT: '/about',
    TRAINING: '/training',
    TRAINING_FUNDAMENTAL_ANALYSIS: '/training/fundamental-analysis',
    TRAINING_TECHNICAL_ANALYSIS: '/training/technical-analysis',
    TRAINING_LONG_POSITION: '/training/long-position',
    TRAINING_SHORT_POSITION: '/training/short-position',
    VIRTUAL_ASSISTANT: '/virtual-assistant',
    AFFILIATE_PROGRAM: '/affiliate-program',
    LOGIN: '/login',
    REGISTER: '/register',
    AFFILIATE_PROGRAM_REGULATIONS: '/affiliate-program-regulations',
    PRIVACY_POLICY: '/privacy-policy',
    TERMS_OF_SERVICE: '/terms-of-service',
    SERVICE_PROVISION_REGULATIONS: '/service-provision-regulations',
    RETURN_POLICY: '/return-policy',
    SUPPORT: '/support',
    SUPPORT_VIDEO: '/support/video-tips-for-beginners',
    SUPPORT_AI: '/support/ai-assistant-guides',
    SUPPORT_ONLINE: '/support/online-support-guides',
    SUPPORT_DISCORD: '/support/discord-support-forum',
    PRICING: '/pricing',
    CONTACT: '/contact',

    INSTAGRAM: 'https://www.instagram.com/lockedtrade/',
    YOUTUBE: 'https://www.youtube.com/@LOCKEDTRADE', // unused
    FACEBOOK: 'https://www.facebook.com/LOCKEDTRADE', // unused
    DISCORD: 'https://discord.gg/frkMb7JTjX',
    TIKTOK_NY: 'https://www.tiktok.com/@locked.trade.new.york',
    TIKTOK_L: 'https://www.tiktok.com/@locked.trade.london',

    LT_SUB_BASIC: 'https://charts.lockedtrade.com/#/subscriptions/basic',
    LT_SUB_PRO_MONTHLY: 'https://charts.lockedtrade.com/#/subscriptions/pro-monthly',
    LT_SUB_PRO_YEARLY: 'https://charts.lockedtrade.com/#/subscriptions/pro-yearly',
    LT_SUB_EXPERT_MONTHLY: 'https://charts.lockedtrade.com/#/subscriptions/expert-monthly',
    LT_SUB_EXPERT_YEARLY: 'https://charts.lockedtrade.com/#/subscriptions/expert-yearly',

    LT_LOGIN_URL: 'https://charts.lockedtrade.com/auth/login/',
    LT_REGISTER_URL: 'https://charts.lockedtrade.com/auth/signup/',
}

export default PATHS;